// extracted by mini-css-extract-plugin
export default {"container":"win_container__rhk4C","main":"win_main__g41ve","more":"win_more__kQdI8"};